export default __webpack_public_path__ + "static/media/image-room.21de126f.png";